module.exports = __webpack_public_path__ + "img/bulle_6_choix_metier.aa55a3b6.png";